import type { AnswerFragment } from '../../../present/activity-answers.graphql.generated';
import type { DrawAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import {
  ACTIVITIES_ANSWER_DRAW_TYPE,
  ACTIVITIES_ANSWER_TEXT,
} from 'global/constants';
import { isRichtextValueEmpty } from '../../shared/logic/get-richtext-value';
import { getRichtextAnswer } from '../../shared/logic/get-richtext-answer';
import { hasDrawAnswer } from '../../shared/logic/has-draw-answer';

export function discussionHasAnswer(answers: AnswerFragment[]) {
  const textAnswer = answers?.find(
    c => c.answerType === ACTIVITIES_ANSWER_TEXT
  );
  const drawAnswer = answers?.find(
    c => c.answerType === ACTIVITIES_ANSWER_DRAW_TYPE
  );
  return (
    !isRichtextValueEmpty(getRichtextAnswer(textAnswer)) ||
    hasDrawAnswer(drawAnswer?.answer as DrawAnswerFragment)
  );
}
